<template class="event-list">
  <require from="components/mobile_app_dashboard/user-location-request"></require>
  <require from="components/mobile_app_dashboard/delayed-panic-request"></require>

  <div class="event" repeat.for="delayedPanicRequest of delayedPanicRequests">
    <delayed-panic-request data.bind="delayedPanicRequest"></delayed-panic-request>
  </div>
  <div class="event" repeat.for="event of events">
    <user-location-request if.bind="event.type === 1" data.bind="event.data"></user-location-request>
  </div>
</template>
